export default __webpack_public_path__ + "static/media/civic-KI.496a84ad.jpg";